export default __webpack_public_path__ + "static/media/downButton.5bacb1b8.svg";